import React from 'react';
import Button from '@components/common/Button';
import PlusSvgIcon from '../../../../assets/svg_main/plus.svg';
import { COMMON_CONSTANTS } from '@constants/index';
import './index.css';
import { buttonNames } from '@constants/appConstants';
import { useSelector } from 'react-redux';
import { RootState } from '@store/reducers';

interface PregnancyActionButtonsProps {
  isDead: boolean;
  onAddServicesClick: () => void;
  onAddPregnancyClick: () => void;
  userRole: string;
}

const PregnancyActionButtons: React.FC<PregnancyActionButtonsProps> = ({
  isDead,
  onAddServicesClick,
  onAddPregnancyClick,
  userRole,
}) => {
  const pregHistoryDetails = useSelector(
    (state: RootState) => state.beneficiary.pregHistoryDetails,
  );

  const isPregnancyAllowed = () => {
    return {
      showErrorMessage: false,
      errorMessage: '',
      isPregnancyAllowed: true,
    };
  };

  return (
    <div className="pregnanacy_service_button">
      {userRole !== COMMON_CONSTANTS.FIELD_LEVEL_USER && (
        <>
          <Button
            onClick={!isDead ? onAddServicesClick : () => {}}
            buttonName={buttonNames.addServicesButton}
            id=""
            disabled={isDead}
            colorType="primary"
            icon={<PlusSvgIcon />}
            iconPosition="left"
          />
          <div className={`pregnancy_add_button_wrapper ${!isPregnancyAllowed()?.isPregnancyAllowed ? 'disabled' : ''}`}>
            <Button
              onClick={!isDead ? onAddPregnancyClick : () => {}}
              buttonName={buttonNames.addPregnancy}
              id=""
              disabled={isDead || !isPregnancyAllowed()?.isPregnancyAllowed}
              colorType="primary"
              icon={<PlusSvgIcon />}
              iconPosition="left"
            />
            {isPregnancyAllowed()?.showErrorMessage && <span className="tooltiptext">{isPregnancyAllowed()?.errorMessage}</span>}
          </div>
        </>
      )}
    </div>
  );
};

export default PregnancyActionButtons;
